export default __webpack_public_path__ + "static/og-preview-f97f3dd83b4985d7810d652334655909.jpg";